import * as yup from "yup";
import { GracePeriodNotificationsType } from "../../components/create/actions-step/components/grace-period/GracePeriodNotifications";
import { integrationNotificationValidationSchema } from "../../../../common/notification-selection/utils/validation/validation";
import { emailsValidationSchema } from "../../../../../common/integration-dialogs/components/email/utils/validation";

export const getGracePeriodEmailsValidationSchema = () => {
  return yup.lazy((data: GracePeriodNotificationsType[0]) => {
    if (data.integration_id) {
      return integrationNotificationValidationSchema;
    }

    return emailsValidationSchema(data);
  });
};
